// Brand-related translations
const brandsTranslations = {
    brand_status: {
        th: "สถานะ",
        en: "Status",
        ja: "ステータス",
    },
    brand_status_draft: {
        th: "draft",
        en: "draft",
        ja: "下書き",
    },
    brand_status_editing: {
        th: "editing",
        en: "editing",
        ja: "編集中",
    },
    brand_status_released: {
        th: "released",
        en: "released",
        ja: "公開",
    },
    brand_status_duplicated: {
        th: "duplicated",
        en: "duplicated",
        ja: "重複",
    },
    brand_status_rejected: {
        th: "rejected",
        en: "rejected",
        ja: "却下",
    },
    brand_note: {
        th: "บันทึก",
        en: "Note",
        ja: "メモ",
    },
    // Floating chat button label on the brand LIST page (ISS-09-008 follow-up):
    // visitors browsing the full brand directory are more likely brand/advertiser
    // contacts than shoppers (brand detail pages get a shopper-facing label instead —
    // see product_search_ask_messenger in dict-products.ts).
    brand_advertise_chat_label: {
        th: "สนใจลงโฆษณากับเรา? สอบถามได้ทาง Messenger",
        en: "Interested in advertising with us? Chat on Messenger.",
        ja: "広告掲載のご相談はMessengerで",
    },
};

export { brandsTranslations };
